import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_KEY;



// Fetch order status dynamically
export const apiOrderInfo = async (setOrderInfo) => {
    const orderId = Number(localStorage.getItem("orderId")) || 0;
    if (!orderId) {
        console.warn("Order ID not found in local storage.");
        return;
    }

    try {
        const response = await axios.get(`${API_BASE_URL}QrOrder/${orderId}/status`);
        if (response.data) {
            setOrderInfo(response.data);
        } else {
            console.warn("No order info found.");
        }
    } catch (error) {
        console.error("Error fetching order info:", error);
    }
};
